import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";
import { LogoV3 } from "@/libraries/wpl/foundations/src";

const rovoSectionStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: `${token("space.200")} ${token("space.400")}`,
    margin: `0 ${token("space.400")} ${token("space.500")}`,
    borderRadius: wacToken("corner.radius.card"),
    border: `1px solid ${wacToken("color.neutral.light300")}`,
    boxShadow: `0 0 0 0 ${wacToken("color.neutral.light100")}`,
    transition: "box-shadow 0.25s",
    [`&:hover`]: {
        boxShadow: token("elevation.shadow.overlay")
    },
    [media.below.md]: {
        marginInlineStart: 0,
        marginInlineEnd: 0,
        maxWidth: "312px",
        padding: `14px ${token("space.250")}`
    }
});

const rovoTitleStyles = css({
    [`&.rovo-title`]: {
        fontSize: token("space.200"),
        lineHeight: 1,
        margin: 0,
        color: wacToken("color.primary.black")
    }
});

const rovoDescriptionStyles = css({
    [`&.rovo-description`]: {
        margin: 0,
        color: wacToken("color.neutral.light800"),
        fontSize: "0.875rem",
        lineHeight: 1.3
    }
});

const rovoLogoContainerStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: token("space.200"),
    [media.below.md]: {
        gap: "12px",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        svg: {
            minWidth: token("space.400"),
            width: token("space.400"),
            height: token("space.400")
        }
    }
});

export const RovoSection = () => {
    return (
        <a
            href={useLocalizedHref("/software/rovo")}
            target="_blank"
            rel="noreferrer"
            data-product-key="rovo"
            data-event-component="linkButton"
            data-event-container="globalNavSubnav"
            data-event="clicked"
            css={rovoSectionStyles}
        >
            <div css={rovoLogoContainerStyles}>
                <LogoV3
                    brand="rovo"
                    type="mark"
                    appearance="brand"
                    width={36}
                    height={36}
                />

                <h3 className="rovo-title" css={rovoTitleStyles}>
                    Rovo
                </h3>
                <p className="rovo-description" css={rovoDescriptionStyles}>
                    <FormattedMessage
                        id="GlobalNav.RovoSection.Title"
                        defaultMessage="AI-powered apps – driven by your team's knowledge."
                    />
                </p>
            </div>
        </a>
    );
};
